import { Check, Minus } from 'lucide-react';
import { tierComparison, tierPriceLabel } from '@/content/addon-tiers';
import type { PublicApp } from '@/content/apps';

/**
 * Tabela «o que muda de um nível para o outro». Vem do catálogo público: nível,
 * preço, franquia e recursos. Sem JavaScript também é legível, porque o HTML
 * sai pronto do build.
 */
export function TierComparison({ app, highlight }: { app: PublicApp; highlight?: string | null }) {
  const data = tierComparison(app);
  if (!data) return null;
  return (
    <div className="tier-compare-wrap">
      <table className="tier-compare">
        <caption className="sr-only">Diferença entre os níveis de {app.name}</caption>
        <thead>
          <tr>
            <th scope="col">
              <span className="sr-only">Recurso</span>
            </th>
            {data.tiers.map((tier) => (
              <th key={tier.code} scope="col" className={tier.code === highlight ? 'is-picked' : undefined}>
                <span className="tier-compare-name">{tier.name}</span>
                <span className="tier-compare-price">{tierPriceLabel(tier)}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((row) => (
            <tr key={row.key}>
              <th scope="row">{row.label}</th>
              {row.values.map((value, index) => (
                <td key={data.tiers[index].code} className={data.tiers[index].code === highlight ? 'is-picked' : undefined}>
                  {value === true ? (
                    <>
                      <Check aria-hidden strokeWidth={3} width={16} height={16} className="tier-yes" />
                      <span className="sr-only">Inclui</span>
                    </>
                  ) : value === false ? (
                    <>
                      <Minus aria-hidden strokeWidth={2.4} width={16} height={16} className="tier-no" />
                      <span className="sr-only">Não inclui</span>
                    </>
                  ) : (
                    value
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
